import React from 'react';
import { number, string } from 'prop-types';

const ChevronDown = ({ width, height, viewBox }) => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={width} height={height} viewBox={viewBox}>
    <path id="a" d="M6.53 8.47a.75.75 0 0 0-1.06 1.06l6 6a.75.75 0 0 0 1.06 0l6-6a.75.75 0 0 0-1.06-1.06L12 13.94 6.53 8.47z" />
  </svg>
);

export default ChevronDown;

ChevronDown.propTypes = {
  width: number,
  height: number,
  viewBox: string,
};

ChevronDown.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
};
